import AnniGiftGraph from './AnniGiftGraph';
import AnniGiftList from './AnniGiftList';
import FormGroup from '../../../Form/FormGroup';
import {
  AnniProjectDetailProps,
  AnniProjectMessage,
  AnniProjectDataType,
  getAnniGoalAmountPer,
} from '../AnniProjectPopupInterface';
import AnniProjectSnsButton from '../share/AnniProjectSnsButton';
import { AttFileControllerService } from '@/__generated__/CommonApi';
import {
  AnniversaryProjectControllerService,
  anniversaryProjectVo,
} from '@/__generated__/FrontApi';
import ImgNodata from '@/assets/img/anniversary/img_nodata.png';
import IconMsg from '@/assets/img/icons/ico_letter_blue@2x.png';
import IconMsg2 from '@/assets/img/icons/ico_msg@2x.png';
import inputTextImg2 from '@/assets/img/involve/box_shape_blue.jpg';
import inputTextImg from '@/assets/img/involve/box_shape_gray.jpg';
import AttachmentPreview from '@/components/AttachmentImage.anni';
import Button from '@/components/Button';
import ErrorMessage from '@/components/Form/ErrorMessage';
import LabelText from '@/components/Form/LabelText';
import Col from '@/components/Grid/Col';
import Row from '@/components/Grid/Row';
import InputDate from '@/components/Input/InputDate';
import InputNumber from '@/components/Input/InputNumber';
import InputText from '@/components/Input/InputText';
import InputTextarea from '@/components/Input/InputTextarea';
import Select from '@/components/Select';
import { breakpoint } from '@/helpers/BreakpointHelper';
import {
  useSupportCategoriesForAnniPrjt,
  useAllSupportAnniType,
} from '@/helpers/SupportAnniPrjtHelper';
import { usePopupStore } from '@/stores/PopupStore';
import { useUserStore } from '@/stores/UserStore';
import React, { FC, useEffect, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const ContentSection = styled.div`
  margin: 30px 0;
  max-width: 768px;
  display: inline-block;
  text-align: initial;
  width: 100%;

  &.no-data {
    text-align: center;
  }
  .top-dec {
    margin-top: 32px;
  }

  .show-msg {
    margin-top: 35px;
  }

  ${breakpoint(`mobile`)} {
    padding: 32px 0 40px;
  }
`;
const FormSection = styled.form`
  padding: 0 0 20px 0;
  margin: 0 0 20px 0;
  border-bottom: 1px solid #e5e6e8;
`;

const SupportFlex = styled.div`
  display: flex;
  justify-content: space-between;

  ${breakpoint(`mobile`)} {
    flex-direction: column;
  }
`;

const H3 = styled.h3`
  font-size: 22px;
  color: #1cabe2;
  font-weight: bold;
  letter-spacing: -0.88px;
  margin-bottom: 15px;

  ${breakpoint(`mobile`)} {
    font-size: 16px;
  }
`;

/* <Text> 안에 서로 다른 3개의 속성에 따른 list style값 */
const Text = styled.span<{
  listStyle?: boolean;
  titStyle?: boolean;
  titStyle2?: boolean;
}>`
  display: inline-block;
  position: relative;
  line-height: 1.7;
  ${({ listStyle }) => {
    if (listStyle) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        background: #1cabe2;
        border-radius: 100%;
        vertical-align: middle;
        margin: -4px 10px 0 4px;

        ${breakpoint(`mobile`)} {
          width: 4px;
          height: 4px;
        }
      }
      `;
    }
    return ``;
  }}
  ${({ titStyle }) => {
    if (titStyle) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 13px;
        background: url(${IconMsg}) no-repeat;
        background-size: contain;
        vertical-align: middle;
        margin: -2px 10px 0 2px;
      }
        `;
    }
    return ``;
  }}
  ${({ titStyle2 }) => {
    if (titStyle2) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 15px;
        background: url(${IconMsg2}) no-repeat;
        background-size: contain;
        vertical-align: middle;
        margin: -2px 10px 0 2px;
      }
        `;
    }
    return ``;
  }}
`;

const ColLeft = styled.div`
  width: calc(50% - 15px);
  picture {
    position: relative;
    width: 100%;
    &::after {
      display: block;
      content: '';
      padding-bottom: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  ${breakpoint(`mobile`)} {
    width: 100%;
    margin-bottom: 15px;
  }
`;

const MsgBox = styled.div`
  background: #f8f9fa;
  padding: 13px 15px 30px;
  ${Text} {
    display: block;
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #bebfc1;
      margin-top: 5px;
    }
  }
  p,
  ${InputTextarea} {
    line-height: 1.625;
    padding-top: 15px;
    min-height: 244px;
    max-height: 244px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 4px;
      background: #e2e3e3;
    }
    &::-webkit-scrollbar-thumb {
      background: #1cabe2;
    }

    ${breakpoint(`mobile`)} {
      min-height: auto;
      max-height: 171px;
    }
  }
  ${breakpoint(`mobile`)} {
    padding: 15px 15px 20px;
  }
`;

const ColRight = styled.div`
  width: calc(50% - 15px);
  ul li {
    i {
      font-family: 'Noto Sans CJK KR';
      font-style: normal;

      &.ico-dday {
        color: #1cabe2;
        font-size: 12px;
        background: #e8f6fc;
        border-radius: 5px;
        line-height: 20px;
        padding: 0 12px;
        margin-left: 7px;
        letter-spacing: 0;
      }
    }

    ${Text} {
      display: block;

      .ico-goal-over {
        position: absolute;
        right: 0;
        bottom: -5px;
        color: #1cabe2;
        font-size: 14px;
        font-weight: normal;
        strong {
          font-size: 18px;
        }
      }
    }
    &:not(:last-child) ${Text} {
      display: inline-block;
      width: 120px;
      ${breakpoint(`mobile`)} {
        width: 111px;
      }
    }
  }

  ${breakpoint(`mobile`)} {
    width: 100%;
  }
`;

const SupportSection = styled.div`
  width: 100%;
  ul li {
    ${Text} {
      display: block;
    }
    &:not(:last-child) ${Text} {
      display: inline-block;
      width: 120px;
      ${breakpoint(`mobile`)} {
        width: 111px;
      }
    }
  }

  .textarea_bgbox {
    position: relative;
    margin: 10px 0 17px;

    &::after {
      content: '';
      display: block;
      width: 43px;
      height: 36px;
      background: url(${inputTextImg}) no-repeat;
      background-size: contain;
      position: absolute;
      top: 0;
      right: 0;
    }
    &:focus-within {
      &::after {
        background: url(${inputTextImg2}) no-repeat;
      }
    }
    ${InputTextarea} {
      height: 232px;
      ${breakpoint(`mobile`)} {
        height: 260px;
      }
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  margin: auto;

  .msg {
    text-align: center;
    width: 100%;
    background: #eee;
    padding: 20px 0;
  }

  ${breakpoint(`mobile`)} {
    padding-left: 0;
    margin-top: 32px;
    button {
      width: 100%;
      margin: 0 auto;
    }
  }
`;
const SnsLinkContainer = styled.div`
  margin: 20px 0 20px 0;
  background: #f8f9fa;
  display: table;
  padding: 16px;
  text-align: center;
  width: 100%;
`;

const AnniProjectAdmin: FC<AnniProjectDetailProps> = ({ ...props }) => {
  const defaultTitle = '';
  const userStore = useUserStore();
  /* ************** handling data ************** */
  const [items, setItems] = useState<any>();
  const [reload, setReload] = useState(0);
  const [isLoadData, setIsLoadData] = useState(false);
  const [anniImageUrl, setAnniImageUrl] = useState('');
  const [anniImageCd, setAnniImageCd] = useState('');
  /* ************** handling form ************** */
  const popupStore = usePopupStore();
  const [images, setImages] = useState<File[]>([]);
  const [isUpdate, setIsUpdate] = useState(false);
  /* 기념기부 종류 */
  const anniTypes = useAllSupportAnniType();
  /* 일시 후원이고 기념기부 제외 출력 */
  const supportCategories = useSupportCategoriesForAnniPrjt();
  /* 폼 활성화 여부 */
  const disabled = !userStore.isLoggedIn();

  const loadItems = useCallback(async () => {
    props.setPopupTitle(defaultTitle);
    setItems(null);
    setAnniImageUrl(ImgNodata);
    setAnniImageCd('');

    AnniversaryProjectControllerService.selectAdminAnniversaryProjectDetailGet({
      indexNumber: props.id,
    })
      .then(({ data, resultCode }) => {
        const resData = data as anniversaryProjectVo;
        setItems(resData);
        if (resultCode === `success`) {
          const img =
            resData?.aprjtAttImg && resData?.imgAttImgTn
              ? resData?.imgAttImgTn
              : `${process.env.SELF_URL}${ImgNodata}`;
          props.setPopupTitle(resData?.aprjtName || defaultTitle);
          setAnniImageUrl(img);
          setAnniImageCd(resData?.aprjtAttImg || '');
        }
        setIsLoadData(true);
      })
      .catch(() => {
        setIsLoadData(false);
      });
  }, [props]);

  useEffect(() => {
    setIsLoadData(false);
    if (props.id === 0) {
      setIsLoadData(false);
    } else {
      loadItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id, reload]);

  /* ********************* 페이지 수정 폼 컨트롤 ****************** */
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<AnniProjectDataType>({
    // 가변 defaultValues
    defaultValues: items,
  });

  useEffect(() => {
    // 사용자 정보가 로딩되거나 Modal Close 시 form reset
    if (userStore.user) {
      // form reset
      reset();

      // images reset
      setImages([]);
    }
  }, [userStore.user, reset, reload]);

  const onSubmit = useCallback(
    async (data: AnniProjectDataType) => {
      if (isUpdate === true) {
        popupStore.show('페이지정보를 저장중입니다. 잠시만 기다려주세요');
        return;
      }
      setIsUpdate(true);

      // date validate
      if (data.goalEndDate && data.goalStartDate) {
        const eDate = new Date(data.goalEndDate || '');
        const sDate = new Date(data.goalStartDate || '');

        if (eDate.getTime() < sDate.getTime()) {
          popupStore.show('목표기간은 시작일이 종료일보다 나중일 수 없습니다.');
          setIsUpdate(false);
          return;
        }
      }

      const supportInforData: any = {
        solicitCode: '',
        supportCode: '',
      };
      // 지원사업 코드 셋팅
      if (data.supportIndexNumber) {
        supportCategories.forEach((item) => {
          if (item.indexNumber === Number(data.supportIndexNumber)) {
            supportInforData.solicitCode = item.solicitCode || '';
            supportInforData.supportCode = item.code || '';
          }
        });
      }

      // update files
      let aprjtAttImg: any = anniImageCd; // 이전 이미지 파일 경로
      if (images.length > 0) {
        const result: any = await AttFileControllerService.uploadUsingPost({
          file: images,
        });
        if (result && result.resultCode === 'success' && result.data) {
          aprjtAttImg = result.data.attGrpNo;
        }
      }

      // 폼데이터로 변환
      const formData = new FormData();
      const finalData = {
        aprjtAttImg: aprjtAttImg || '',
        ...supportInforData,
        ...data,
      };
      Object.keys(finalData).forEach((key) => {
        if (finalData[key] !== undefined) {
          formData.append(key, finalData[key]);
        }
      });

      // update form
      try {
        const submitRes: any = await AnniversaryProjectControllerService.updateAnniversaryProjectUsingPost(
          finalData,
        );

        setIsUpdate(false);

        if (submitRes?.resultCode === 'success') {
          // success
          popupStore.show('페이지가 수정되었습니다.');
          if (submitRes?.data?.idx === 0) {
            props.onRequestClose();
          } else {
            // 데이터 리로드
            setReload(reload + 1);
          }
        } else {
          // error
          popupStore.show(
            '페이지 수정에 실패했습니다. 잠시후에 다시 시도해주세요.',
          );
        }
      } catch (e) {
        popupStore.show(
          '페이지 수정에 실패했습니다. 잠시후에 다시 시도해주세요.',
        );

        setIsUpdate(false);
      }
    },
    [
      isUpdate,
      anniImageCd,
      images,
      popupStore,
      supportCategories,
      props,
      reload,
    ],
  );

  if (isLoadData === false)
    return (
      <ContentSection className="no-data">
        {AnniProjectMessage.PageLoading}
      </ContentSection>
    );

  if (!items) {
    props.setPopupTitle(AnniProjectMessage.DefaultTitle);
    return (
      <ContentSection className="no-data">
        {AnniProjectMessage.PageNotFound}
      </ContentSection>
    );
  }

  /* ********************* 정상적인 접근일 경우 페이지 랜더링 ****************** */

  return (
    <ContentSection>
      <H3>기념기부 관리</H3>
      <FormSection onSubmit={handleSubmit(onSubmit)}>
        <input
          type="hidden"
          name="aprjtIdx"
          ref={register}
          value={items?.aprjtIdx || ''}
        />
        <SupportFlex>
          <ColLeft>
            <FormGroup>
              <Text listStyle>
                <LabelText>
                  <b>사진</b>
                </LabelText>
              </Text>
              <AttachmentPreview
                maxFileCount={1}
                files={images}
                onFilesChange={setImages}
                accept="image/*"
                disabled={disabled}
                defaultImg={anniImageUrl}
                fullsize
              />
            </FormGroup>

            <MsgBox>
              <FormGroup>
                <Text titStyle2>
                  <LabelText>
                    <b>메시지</b>
                  </LabelText>
                </Text>
                <InputTextarea
                  name="aprjtMessage"
                  ref={register({
                    required: {
                      value: true,
                      message: `필수 입력입니다`,
                    },
                    maxLength: {
                      value: 1000,
                      message: '메시지는 최대 1000자까지 입력 가능합니다.',
                    },
                  })}
                  placeholder="메시지를 입력해주세요(1000자 이내)"
                  maxLength={1000}
                  disabled={disabled}
                  defaultValue={items.aprjtMessage}
                />
                {errors.aprjtMessage && (
                  <ErrorMessage>{errors.aprjtMessage.message}</ErrorMessage>
                )}
              </FormGroup>
            </MsgBox>
          </ColLeft>
          <ColRight>
            <ul>
              <li>
                <FormGroup>
                  <Text listStyle>
                    <LabelText>
                      <b>페이지명</b>
                    </LabelText>
                  </Text>
                  <span>
                    <InputText
                      name="aprjtName"
                      ref={register({
                        required: {
                          value: true,
                          message: `필수 입력입니다`,
                        },
                      })}
                      placeholder="페이지명 입력"
                      maxLength={20}
                      disabled={disabled}
                      defaultValue={items.aprjtName}
                      css="text-overflow: ellipsis;"
                    />
                  </span>
                  {errors.aprjtName && (
                    <ErrorMessage>{errors.aprjtName.message}</ErrorMessage>
                  )}
                </FormGroup>
              </li>
              <li>
                <FormGroup>
                  <Text listStyle>
                    <LabelText>
                      <b>기념일 종류</b>
                    </LabelText>
                  </Text>
                  <span>
                    <Select
                      name="anniType"
                      ref={register({
                        required: {
                          value: true,
                          message: `필수 입력입니다`,
                        },
                      })}
                      disabled={disabled}
                      defaultValue={items?.anniType}
                    >
                      <option value="">기념일 종류 선택</option>
                      {anniTypes.map((a) => (
                        <option
                          key={a.code}
                          value={a.code}
                          data-name={a.codeName}
                        >
                          {a.codeName}
                        </option>
                      ))}
                    </Select>
                  </span>
                  {errors.anniType && (
                    <ErrorMessage>{errors.anniType.message}</ErrorMessage>
                  )}
                </FormGroup>
              </li>
              <li>
                <FormGroup>
                  <Text listStyle>
                    <LabelText>
                      <b>후원자 기념일</b>
                    </LabelText>
                  </Text>
                  <span>
                    <InputDate
                      name="anniDate"
                      css="width:100%;"
                      ref={register({
                        required: {
                          value: true,
                          message: `필수 입력입니다`,
                        },
                      })}
                      disabled={disabled}
                      initialDate={items?.anniDate}
                    />
                  </span>
                  {errors.anniDate && (
                    <ErrorMessage>{errors.anniDate.message}</ErrorMessage>
                  )}
                </FormGroup>
              </li>
              <li>
                <FormGroup>
                  <Text listStyle>
                    <LabelText>
                      <b>목표금액</b>
                    </LabelText>
                  </Text>
                  <span>
                    <InputNumber
                      name="goalAmount"
                      placeholder="목표금액 입력(숫자만입력)"
                      ref={register({
                        required: {
                          value: true,
                          message: `필수 입력입니다`,
                        },
                        min: {
                          value: 1,
                          message: '목표금액은 0원 이상 입력해주세요.',
                        },
                      })}
                      disabled={disabled}
                      defaultValue={items.goalAmount}
                    />
                  </span>
                  {errors.goalAmount && (
                    <ErrorMessage>{errors.goalAmount.message}</ErrorMessage>
                  )}
                </FormGroup>
              </li>
              <li>
                <FormGroup>
                  <Text listStyle>
                    <LabelText>
                      <b>목표기간</b>
                    </LabelText>
                  </Text>
                  <span>
                    <Row>
                      <Col desktop={6} mobile={3}>
                        <InputDate
                          name="goalStartDate"
                          css="width:100%;"
                          ref={register({
                            required: {
                              value: true,
                              message: `필수 입력입니다`,
                            },
                          })}
                          disabled={disabled}
                          initialDate={items.goalStartDate}
                        />
                      </Col>
                      <Col align="center" desktop={1} mobile={1}>
                        ~
                      </Col>
                      <Col desktop={6} mobile={3}>
                        <InputDate
                          name="goalEndDate"
                          css="width:100%;"
                          ref={register({
                            required: {
                              value: true,
                              message: `필수 입력입니다`,
                            },
                          })}
                          disabled={disabled}
                          initialDate={items.goalEndDate}
                        />
                      </Col>
                    </Row>
                  </span>
                  {errors.goalStartDate
                    ? errors.goalStartDate && (
                        <ErrorMessage>
                          {errors.goalStartDate.message}
                        </ErrorMessage>
                      )
                    : errors.goalEndDate && (
                        <ErrorMessage>
                          {errors.goalEndDate.message}
                        </ErrorMessage>
                      )}
                </FormGroup>
              </li>
            </ul>
            <ButtonContainer>
              {items.displayStateTypeCode === '3' ? (
                <Button full type="submit">
                  {AnniProjectMessage.DefaultTitle} 수정
                </Button>
              ) : (
                <p className="msg">
                  {items.displayStateTypeCode === '2' ? (
                    <strong>
                      관리자에 의해 &apos;{AnniProjectMessage.DefaultTitle}
                      &apos; 페이지
                      <br /> 수정이 진행 중 입니다.
                    </strong>
                  ) : (
                    <strong>{items.displayStateTypeName} 상태입니다.</strong>
                  )}
                </p>
              )}
            </ButtonContainer>
            <ul>
              <li>
                <SnsLinkContainer>
                  <AnniProjectSnsButton
                    text={items?.aprjtName || '유니세프 기념기부'}
                    url={items?.anniSnsShareUrl || ``}
                    imgUrl={anniImageUrl || ''}
                  />
                </SnsLinkContainer>
              </li>
              <li>
                {/** 후원금액 그래프 */}
                <Text listStyle>
                  <b>목표금액 대비 후원금액</b>
                  {getAnniGoalAmountPer(
                    items.goalAmount || 0,
                    items?.giftTotalAmountInfo?.totalAmount || 0,
                  ) > 100 ? (
                    <i className="ico-goal-over">
                      <strong>
                        {getAnniGoalAmountPer(
                          items.goalAmount || 0,
                          items?.giftTotalAmountInfo?.totalAmount || 0,
                        )?.toLocaleString()}
                      </strong>
                      % 달성
                    </i>
                  ) : (
                    <></>
                  )}
                </Text>
                <AnniGiftGraph
                  total={items?.giftTotalAmountInfo?.totalAmount || 0}
                  goal={items?.goalAmount || 0}
                />
              </li>
            </ul>
          </ColRight>
        </SupportFlex>
      </FormSection>

      {/* 230227 고객사 요청으로 삭제
      <H3>후원 참여 하기</H3>
      <SupportSection>
        {/** 기부참여 폼 * /}
        <AnniGiftForm
          onRequestClose={() => {
            props.onRequestClose();
          }}
          datas={items}
        />
      </SupportSection>
      */}

      {/** 기부참여자 목록 */}
      <AnniGiftList action={props.action} datas={items} />
    </ContentSection>
  );
};

export default AnniProjectAdmin;
